var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6c756f9020aaf5683a6148fe9ddb8523e2b3a9e1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@penusa"]={id:"6c756f9020aaf5683a6148fe9ddb8523e2b3a9e1"};
      